{
    "GenericAdminFilterLanguage_CME_LABEL": "ECM",
    "GenericAdminFilterLanguage_TELSYS_LABEL": "Server di telefonia",
    "GenericAdminFilterLanguage_PARTITION_LABEL": "Partizione",
    "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "Tipo di CRM",
    "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Includi elementi CME per bambini",
    "GenericAdminFilterLanguage_SEARCH_LABEL": "Ricerca",
    "NAME": "GenericAdminFilterLanguage",
    "GenericAdminFilterLanguage_OPTION_ALL_LABEL": "Tutto",
    "GenericAdminFilterLanguage_OPTION_ANY_LABEL": "Qualunque",
    "GenericAdminFilterLanguage_OPTION_NONE_LABEL": "Nessuno",
    "GenericAdminFilterLanguage_PLEASE_SELECT_OPTION_TO_SHOW_RESULTS": "Seleziona un'opzione per visualizzare i risultati."
}